import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../public/icons/workflow/close.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-2a537620"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editor m-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Set parameter values", -1))
const _hoisted_3 = { class: "child-editor" }
const _hoisted_4 = { style: {"margin":"0 auto"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormParameterEditor = _resolveComponent("FormParameterEditor")!
  const _component_CommonButton = _resolveComponent("CommonButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "theme-svg",
      src: _imports_0,
      id: "close",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.Cancel && _ctx.Cancel(...args)))
    }),
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CurrentParameters.parameters, (param, i) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("label", null, _toDisplayString(param.name), 1),
        _createVNode(_component_FormParameterEditor, {
          param: param,
          onUpdate: ($event: any) => {param.currentValue = $event;}
        }, null, 8, ["param", "onUpdate"])
      ]))
    }), 256)),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_CommonButton, {
        type: _ctx.ButtonType.Primary,
        isDanger: true,
        text: _ctx.Localizer.Localize('Cancel_PascalCase'),
        onClick: _ctx.Cancel
      }, null, 8, ["type", "text", "onClick"]),
      _createVNode(_component_CommonButton, {
        type: _ctx.ButtonType.Primary,
        text: _ctx.Localizer.Localize('Run_PascalCase'),
        onClick: _ctx.Run
      }, null, 8, ["type", "text", "onClick"])
    ])
  ]))
}